/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const deleteApiProjectprioritiesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const deleteApiProjectprioritiesId200Schema = z.any();

export const deleteApiProjectprioritiesIdMutationResponseSchema = z.lazy(
  () => deleteApiProjectprioritiesId200Schema,
);
